import { Box, IconButton, Tooltip, styled } from '@mui/material'
import { KeyboardDoubleArrowRight as ChevronDoubleRightIcon } from '@mui/icons-material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { UI_FONT_SIZE, ICON_SIZE } from '@/shared/styles/typography'

interface Props {
  breadcrumb?: string[]
  showSidebarToggle?: boolean
  onToggleSidebar?: () => void
}

// TopBar は sidebar 開閉 toggle (closed 時) と breadcrumb のみで chrome なし。
// borderBottom や厚い padding はかつて user button 等を抱えていた頃の名残なので撤去。
const Bar = styled(Box)({
  height: 44,
  padding: '0 12px',
  display: 'flex',
  alignItems: 'center',
  background: colorTokens.bg.default,
  // 狭幅で breadcrumb が長くてもトグルを押し出さず横スクロールも出さない.
  overflow: 'hidden',
})

const Crumb = styled('span')({
  fontSize: UI_FONT_SIZE.label,
  color: colorTokens.fg.muted,
})

const Separator = styled('span')({
  color: colorTokens.fg.faint,
  margin: '0 6px',
})

// Notion 流の minimal TopBar: sidebar 開閉 toggle と breadcrumb のみ。
// user info / logout は portal に集約 (TopBar の右端に user 名を出すのは Notion ではない)。
export const TopBar = ({
  breadcrumb,
  showSidebarToggle,
  onToggleSidebar,
}: Props) => {
  return (
    <Bar>
      {showSidebarToggle && onToggleSidebar ? (
        <Tooltip title="サイドバーを開く">
          <IconButton
            size="small"
            onClick={onToggleSidebar}
            sx={{ mr: 1, p: 0.5 }}
          >
            <ChevronDoubleRightIcon sx={{ fontSize: ICON_SIZE.md }} />
          </IconButton>
        </Tooltip>
      ) : null}
      {breadcrumb && breadcrumb.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            minWidth: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {breadcrumb.map((seg, i) => (
            <Box key={i} sx={{ display: 'inline-flex', alignItems: 'center' }}>
              {i > 0 && <Separator>/</Separator>}
              <Crumb>{seg}</Crumb>
            </Box>
          ))}
        </Box>
      )}
    </Bar>
  )
}
